/* eslint-disable arrow-body-style */
import React from 'react'
import { Container as SemanticContainer } from 'semantic-ui-react'

const BaseContainer = ({ style, settings, children }) => (
  <SemanticContainer style={style} {...settings}>
    {children}
  </SemanticContainer>
)

const Container = ({
  renderElement,
  renderChildren,
  ...props,
}) => {
  return (
    renderElement(
      BaseContainer,
      { ...props, children: renderChildren() },
    )
  )
}

Container.propTypes = {}
Container.defaultProps = {}

export default Container



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/Container.js